import { uniq } from 'lodash';
import {
  ADD_NOTIFICATION,
  CLOSE_DEACTIVATE_USERS_MODAL,
  CLOSE_NOTIFICATION,
  END_REQUEST_LOADING,
  OPEN_DEACTIVATE_USERS_MODAL,
  START_REQUEST_LOADING,
  UIReducerProps,
} from '../../actions/ui/types';

export const initialState = {
  loading: false,
  pendingRequests: [],
  notifications: [],
  deactivateUserModal: { isOpen: false, userToDeactivate: null },
};

export default function ui(state: UIReducerProps = initialState, action: any) {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };
    case CLOSE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          ({ id }: any) => id !== action.payload
        ),
      };

    case START_REQUEST_LOADING: {
      return {
        ...state,
        pendingRequests: uniq([...state.pendingRequests, action.payload]),
      };
    }

    case END_REQUEST_LOADING: {
      return {
        ...state,
        pendingRequests: state.pendingRequests.filter(
          (call) => call !== action.payload
        ),
      };
    }
    case OPEN_DEACTIVATE_USERS_MODAL: {
      return {
        ...state,
        deactivateUserModal: { isOpen: true, userToDeactivate: action.payload },
      };
    }
    case CLOSE_DEACTIVATE_USERS_MODAL: {
      return {
        ...state,
        deactivateUserModal: { isOpen: false, userToDeactivate: null },
      };
    }
    default:
      return state;
  }
}
